import { ASM, C, CPP, CSS, C_SHARP, HTML, JAVA, JAVA_SCRIPT, MATLAB, PYTHON, SQL, VERILOG } from "./LogoPath";

export const LANGUAGE_ICONS = [PYTHON, C, CPP, C_SHARP, JAVA, JAVA_SCRIPT, HTML, CSS, SQL, MATLAB, VERILOG, ASM];
